import { createSelector } from '@ngrx/store';
import { appRootSelector } from '@root/selectors/app-root.selectors';

export const keywordSelector = createSelector(appRootSelector, state => state.keywords);

export const selectDisciplines = createSelector(keywordSelector, state => state.disciplines);
